import {
    IconClockTable,
    IconTraffic, MarkerTitle,
    OutlinedCalendarIcon
} from "../../../../../components/buttons/IconButtons";
import { CustomDateRangePicker } from "../../../../../components/CustomDateRangePicker";
import CustomExpandableCard from "../../../../../components/CustomExpandableCard";
import ZoneLeaflet from "../../../../../components/ZoneLeaflet";
import FinesMapApp from "../Functionality/FinesMapApp";
import TrafficDetailsModal from "../Modal/TrafficDetailsModal";
import {Box} from "@mui/material";
import React, {useEffect} from "react";
import {CommonMapApp} from "../../../../../components/Leaflet/CommonMapApp";
import CardListMap from "../../../Company/Payroll/Subcomponents/CardListMap";
import CustomTooltip from "../../../../../components/CustomTooltip";
import {
    DATE_TIME_FORMAT_MODEL,
    DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES,
    getDateFormat,
} from "../../../../../Apis/functions";
import CustomChip from "../../../../../components/CustomChip";
import {colors} from "../../../../../enums/colors";
import SpeedIndicator from "./SpeedIndicator";
import {TABLES} from "../../../../../Apis/Tables";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {getStatusNameById} from "../../../../../enums/statusEnum";
import NotInformation from "../../../../../components/NotInformation";
import AddEditFineModal from "../Modal/AddEditFineModal";
import {userType} from "../../../../../enums/userTypeEnum";
import {ACTION_MODEL} from '../../../../../Helpers/ActionModel';

/**
 * @Email azapata@ibl.mx
 * @Author Ferro Zapata Arnulfo
 * @jobTitle Full Stack Developer
 * @createdAt 2025-10-07
 *
 * @description
 * Component that renders the interactive map for fines visualization.
 * It uses FinesMapApp to manage its logic, state, and handlers.
 */
const FinesMap = ({ setTotalElements, selectEmployee, setSelectEmployee, reset, setReset,
                      showFinesModal, setShowFinesModal, handleMapMove, direction, setDirection,
                      setCriteria,  setBodyForExport, setSearch
}) => {

    const {
        getActionsButtons,
        setItemSelected,
        item,
        setItem,
        setShowDetailsModal,
        locations,
        showDetailModal,
        itemSelected,
        searchLocation,
        handleChange,
        dispatch,
        t,
        fineList,
        fineListByUserId,
        searchType,
        listContainerRef,
        loadingMore,
        setOptionModal,
        optionModal
    } = FinesMapApp({
        selectEmployee,
        setSelectEmployee,
        reset,
        setDirection,
        setCriteria,
        setBodyForExport,
        setSearch
    });

    const { companyIcon, marker, handleMarkerHover } = CommonMapApp({
        t,
        locations,
        dispatch,
    });

    const activeList = selectEmployee && fineListByUserId && searchType === TABLES.USER
        ? fineListByUserId
        : fineList;

    useEffect(()=>{
        setTotalElements(activeList?.totalElements ?? 0)
    },[activeList])

    return (
        <div className="w-100 h-100 border-full-shades-100 border-radius-8px position-relative overflow-hidden">
            <ZoneLeaflet
                setLatitude={(value) => handleChange({ target: { name: "latitude", value } })}
                setLongitude={(value) => handleChange({ target: { name: "longitude", value } })}
                latlng={[item?.latitude, item?.longitude]}
                searchLocation={searchLocation}
                markersList={marker}
                disabled={true}
                iconMarker={companyIcon}
                onMarkerClick={(item) => {
                    if (item?.id) {
                        setOptionModal(ACTION_MODEL.DETAILS);
                        setItemSelected(item.id);
                        setShowDetailsModal(true);
                    }
                }}
                onMarkerHover={handleMarkerHover}
                onMapMove={handleMapMove}
                ifCluster={true}
            />

            <CustomExpandableCard
                dividerClassName="background-shades-200 mt-2 mb-2"
                header={
                    <div className="row p-0 m-0 gap-3 h-36px">
                        <CustomTooltip
                            text={direction}
                            classes={"pl-0 fs-12px ibl-font-w-500 font-color-primary-700 text-ellipsis-2-rows"}
                            showIfTruncated={true}
                            placement={"top"}
                        />
                    </div>
                }
                searchInput = {
                    <Box className={"mt-3"}>
                        <CustomDateRangePicker
                            id="dp_fm_date_range"
                            name="dateRange"
                            disabled={false}
                            trans="date_range"
                            required={true}
                            rangeData={item}
                            setRangeDate={setItem}
                            maxDate ={new Date()}
                        />
                    </Box>
                }
            >
                <div key={searchType}
                     ref={listContainerRef}
                     className={`minh-275px  ${activeList?.totalElements > 0 ? "overflow-y-auto" : " "}`}
                >
                    {activeList?.totalElements > 0 ?
                        activeList?.content?.map((item, index) => (
                            <CardListMap
                                key={item.id}
                                icon={<IconTraffic className="btn-icon-svg-24px" />}
                                body={
                                    <>
                                        <div className={"flex-row d-flex justify-content-between"}>
                                            <div className={"flex-grow-1 minw-0"}>
                                                <CustomTooltip
                                                    text={item?.fullName}
                                                    classes={"font-color-general-950 ibl-font-w-600 fs-16px text-ellipsis-1-row"}
                                                    showIfTruncated={true}
                                                    placement={"top"}
                                                />
                                            </div>
                                            <div className="vertical-separator-shades-950 mx-2 flex-shrink-0" />
                                            <CustomChip
                                                legend={userType[item?.userTypeId] ? t(userType[item?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                                                fontColor={colors.secondary700}
                                                borderColor={colors.secondary150}
                                                background={colors.secondary100}
                                            />
                                            {getActionsButtons(item, index)}
                                        </div>
                                        <div className="d-flex justify-content-start align-items-center gap-46px">
                                            <div className={"d-flex align-items-center gap-1"}>
                                                <div className={"d-flex align-items-center"}>
                                                    <OutlinedCalendarIcon className="icon-color-shades-500" width={14} height={14}/>
                                                </div>
                                                <span className="text-capitalize ibl-font-w-400 fs-14px  font-color-shades-500">
                                                    {getDateFormat(item?.fineDate , false , DATE_TIME_FORMAT_MODEL.es.shortMonth)}
                                                </span>
                                            </div>
                                            <div className={"d-flex align-items-center gap-1"}>
                                                <div className={"d-flex align-items-center"}>
                                                    <IconClockTable className="icon-color-shades-500" width={14} height={14}/>
                                                </div>
                                                <p className="text-capitalize ibl-font-w-400 fs-14px  font-color-shades-500">
                                                    {getDateFormat(item?.fineDate , false , DATE_TIME_FORMAT_NAME_MODEL.HHmm)}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-start align-items-center gap-46px">
                                            <div className="ibl-font-w-400 font-color-shades-500 fs-14px d-flex align-items-center mr-8px">
                                                <div className={"d-flex align-items-center"}>
                                                    <MarkerTitle width={14} height={14}/>
                                                </div>

                                                <div className={"flex-grow-1 minw-0"}>
                                                    <CustomTooltip
                                                        text={item?.geofenceName}
                                                        classes={"font-color-shades-500 ibl-font-w-600 fs-14px text-ellipsis-1-row"}
                                                        showIfTruncated={true}
                                                        placement={"top"}
                                                    />
                                                </div>
                                            </div>
                                            <SpeedIndicator
                                                speed={item?.speed}
                                                speedUnit={item?.speedUnit}
                                                iconClass="icon-color-error-code-500"
                                                textClass="font-color-error-500"
                                            />
                                        </div>
                                        <div className="d-flex justify-content-end">
                                            <CustomChip
                                                background={statusColor[item?.statusId]}
                                                fontColor={statusFontColor[item?.statusId]}
                                                borderColor={statusBorderColor[item?.statusId]}
                                                legend={t(getStatusNameById(item?.statusId) || '')}
                                                variant={"large"}
                                            />
                                        </div>
                                    </>
                                }
                            />
                        )) : <NotInformation card={true} text={t('no_results_found_for_the_date')}/>
                    }
                    {loadingMore && (
                        <div className="fs-16px ibl-font-w-600 font-color-general-950 text-center">
                            {t("loading")}
                        </div>
                    )}
                </div>
            </CustomExpandableCard>

            {showDetailModal &&
                <TrafficDetailsModal
                    t={t}
                    show={showDetailModal}
                    onHide={() => setShowDetailsModal(false)}
                    itemSelected={itemSelected}
                    optionModal={optionModal}
                />
            }
            {showFinesModal &&
                <AddEditFineModal
                    show={showFinesModal}
                    onHide={() => setShowFinesModal(false)}
                    setModified={setReset}
                />
            }
        </div>
    );
};

export default FinesMap;
